import React from 'react';
import {
    Globe,
    Settings,
    Cloud,
    Brain,
    ShieldCheck
} from 'lucide-react';
import { motion } from 'framer-motion';
import './Services.css';

const servicesData = [
    {
        icon: <Globe size={32} strokeWidth={1.5} />,
        title: "Digital Experiences",
        items: ["Web Development", "Mobile Applications", "UI/UX Design"]
    },
    {
        icon: <Settings size={32} strokeWidth={1.5} />,
        title: "Business Systems",
        items: ["Custom Software", "Employee Management Systems", "Enterprise Applications", "Systems Integration"]
    },
    {
        icon: <Cloud size={32} strokeWidth={1.5} />,
        title: "Digital Infrastructure",
        items: ["Cloud Infrastructure", "DevOps", "Deployment", "Scalable Architectures"]
    },
    {
        icon: <Brain size={32} strokeWidth={1.5} />,
        title: "Intelligent Solutions",
        items: ["AI & Automation", "Business Process Automation", "Data & Analytics"]
    },
    {
        icon: <ShieldCheck size={32} strokeWidth={1.5} />,
        title: "Security",
        items: ["Cybersecurity", "Secure Systems", "Infrastructure Protection"]
    }
];

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.1 }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const Services = () => {
    return (
        <section id="services" className="services-section-light">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <span className="section-badge">Capabilities</span>
                    <h2 className="section-title text-dark">What We Build</h2>
                    <p className="section-description">
                        We deliver a full spectrum of engineering capabilities, designed to modernize your operations and accelerate growth.
                    </p>
                </motion.div>

                <motion.div
                    className="services-grid-new"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                >
                    {servicesData.map((service, index) => (
                        <motion.div key={index} variants={itemVariants} className="service-card-new">
                            <div className="service-icon-new">
                                {service.icon}
                            </div>
                            <h3 className="service-title-new">{service.title}</h3>
                            <ul className="service-list-new">
                                {service.items.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Services;
